<div class="d-flex flex-column">
    @if (filtersReady) {
        <report-manager-select-entities
            [report]="report"
            [hideTopLevelCompanyPicker]="report.criteria.hideTopLevelCompanyPicker"
            [entitySelection]="report.criteria.entitySelection"
            [dataLoaded]="!loading"
            [collapsible]="true"
            [(showBody)]="showFilters"
            (entityRowsChanged)="onEntitySelectionChanged()"
        ></report-manager-select-entities>
    }
    <div class="card panel-flat-color primary-panel">
        <div class="panel-flat-header pointer" (click)="showFurtherLimit = !showFurtherLimit">
            <panel-chevron [showBody]="showFurtherLimit"></panel-chevron>
            <div class="header-icon"><i class="fa fa-building-o"></i></div>
            <h3>Further Limit The Attachment Content</h3>
        </div>
        @if (showFurtherLimit) {
            <div class="panel-flat-body">
                <further-limit-panel-attachment-bundler
                                [report]="report"
                                [availableYears]="availableYears"
                                [filterScope]="filterScope"
                                [entityTypeFilters]="entityTypeFilters"
                                [disabled]="!hasSelection"
                ></further-limit-panel-attachment-bundler>
            </div>
        }
    </div>
    <div class="d-flex">

        <button
            type="button"
            class="ace-btn btn-sm btn-primary text-nowrap align-self-start"
            data-qa="bundler-apply-filters"
            [disabled]="!hasSelection || loading"
            (click)="applyFilters()">
            Apply Filters
        </button>
        @if (loading) {
            <button type="button"
                    class="ace-btn btn-sm btn-secondary btn-danger"
                    data-qa="bundler-loading-cancel"
                    (click)="cancelLoading()">
                Cancel
            </button>
        }
    </div>
</div>

